export default __webpack_public_path__ + "static/media/js.029642bb.svg";